import React, { useState } from 'react'
import { useWizardState } from 'components/dashboard/wizard/WizardStateContext'
import { ConditionFlowContext } from 'components/ui/form/ConditionRulesField/ConditionFlow'
import { useConditionsSources } from 'hooks/useConditionsSources'
import NewFormStep from 'components/ui/form/ConditionRulesField/ConditionFlow/NewFormStep'
import { useCreateZone } from 'hooks/useZones'
import { useConditionRulesField } from 'components/ui/form/ConditionRulesField/Provider'

import SelectForm from './SelectForm'

const NewForm = ({ toggleMode }: { toggleMode: () => void }) => {
    const wizard = useWizardState({ context: ConditionFlowContext })
    const { createZone } = useCreateZone()
    const { zones } = useConditionsSources()
    const { setErrors, setLoading } = useConditionRulesField()

    const handleSubmit = (values) => {
        setLoading(true)

        createZone(values, {
            onSuccess: ({ data }: any) => {
                zones.refetch()
                wizard.setContext((prev) => ({
                    ...prev,
                    zoneIds: [...(prev.zoneIds || []), data.id],
                }))
                toggleMode()
                setLoading(false)
            },
            onError: (errors: any) => {
                setErrors(errors)
                setLoading(false)
            },
        })
    }

    return (
        <NewFormStep
            conditionType="shippingZones"
            formConfig="new_shipping_zone_form"
            onBack={toggleMode}
            onSubmit={handleSubmit}
        />
    )
}

const SelectStep = () => {
    const [selectMode, setSelectMode] = useState(true)
    const toggleMode = () => setSelectMode((prev) => !prev)

    return selectMode ? (
        <SelectForm toggleMode={toggleMode} />
    ) : (
        <NewForm toggleMode={toggleMode} />
    )
}

export default SelectStep
